import React from 'react';
import { OPP_ICONS, BulbIcon, ArrowRightIcon, SectionHeader } from './primitives';

// Coaching: an observation, the money at stake (chip), the advice, optional CTA.
// Complements Finance's AI insights; Catalogue-scoped and behaviour-first.
export const OpportunityCard = ({ icon = 'bulb', tone = 'teal', metric, money, advice, cta, style }) => {
  const Icon = OPP_ICONS[icon] || BulbIcon;
  return (
    <div className={`cd-opp cd-opp--${tone}`} style={style}>
      <span className="cd-opp-icon"><Icon size={19} /></span>
      <div className="cd-opp-body">
        <div className="cd-opp-metric">{metric}</div>
        {money && <span className="cd-opp-money">{money}</span>}
        {advice && <p className="cd-opp-advice">{advice}</p>}
        {cta && (
          <button type="button" className="cd-opp-cta" onClick={cta.onClick}>
            {cta.label} <ArrowRightIcon size={13} />
          </button>
        )}
      </div>
    </div>
  );
};

export const OpportunityList = ({ items = [], title, action }) => (
  <div>
    {title && <SectionHeader title={title} action={action} />}
    {items.length === 0 ? (
      <p className="cd-empty">No opportunities to flag in this period. Nicely done.</p>
    ) : (
      <div className="cd-opp-list">
        {items.map((it, i) => <OpportunityCard key={it.id || i} {...it} style={{ animationDelay: `${i * 60}ms` }} />)}
      </div>
    )}
  </div>
);
